import Button from '@ixigo/iui/Button';
import { SpinningLoaderContent } from '@repo/shared/components';
import { Fragment } from 'react';
import { NavigationHeader } from '@/components';
import { TripDetailsCard } from '@/components/trip-details-card';
import { LOADER_DESCRIPTIONS } from '../constants';
import type { RescheduleError, RescheduleStep } from '../index.types';
import type { RescheduleTripDetail } from '../reschedule';
import { ModifyDetail } from './modify-detail';
import { RescheduleFailure } from './result-screens';

interface RescheduleContentProps {
	step: RescheduleStep;
	error: RescheduleError | null;
	tripDetail: RescheduleTripDetail;
	currentDateTime: string;
	onContinue: (newDateTime?: string) => void;
	onBack: () => void;
	onGetHelp: () => void;
	onTryAgain: () => void;
}

export function RescheduleContent({
	step,
	error,
	tripDetail,
	currentDateTime,
	onContinue,
	onBack,
	onGetHelp,
	onTryAgain,
}: RescheduleContentProps) {
	const { rideDetails, cabDetail, rescheduleDetail } = tripDetail;

	if (step === 'failure' && error) {
		return (
			<RescheduleFailure
				error={error}
				onClose={onBack}
				onGetHelp={() => {
					onGetHelp();
					onBack();
				}}
				onTryAgain={onTryAgain}
			/>
		);
	}

	return (
		<Fragment>
			<NavigationHeader
				title="Reschedule Cab"
				leftAction={onBack}
				className="border-b border-tertiary"
			/>
			<div className="bg-tertiary flex-1 flex flex-col gap-y-10">
				<div className="bg-primary p-20 flex flex-col gap-y-15">
					<TripDetailsCard rideDetails={rideDetails} cabInfo={cabDetail} />
				</div>
				<ModifyDetail
					rideDetails={rideDetails}
					note={rescheduleDetail?.note}
					currentDateTime={currentDateTime}
					onContinue={onContinue}
				/>
			</div>
			<div className="sticky bottom-0 w-full bg-primary border-t border-tertiary px-20 py-2.5">
				<Button onClick={() => onContinue()} className="w-full" size="lg">
					Continue
				</Button>
			</div>

			{(step === 'loading-cabs' || step === 'processing') && (
				<SpinningLoaderContent
					descriptions={[...LOADER_DESCRIPTIONS[step]]}
					className="fixed top-0 left-0 h-screen w-screen flex flex-col gap-2.5 justify-center items-center bg-primary"
				/>
			)}
		</Fragment>
	);
}
